import { render } from "./AccountDetails.vue?vue&type=template&id=11e4851a"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"

import "./AccountDetails.vue?vue&type=style&index=0&id=11e4851a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__